<template>
  <div class="page_bg">
    <div class="container">
      <div class="row">
        <div class="main_inventory">
          <div class="position-relative img_main">
            <div class="top-label">
              <div class="inventory-label">
                <img
                  src="/images/inventory-label.png"
                  class="img-fluid"
                  alt=""
                />
                <h3>Inventory</h3>
              </div>
            </div>

            <div class="top_btns">
              <a
                href="#"
                class="inventory_btn mr-0 mr-lg-4"
                @click.prevent="
                  info = [];
                  init('characters');
                "
              >
                <img src="/images/character-img.png" class="img-fluid" alt="" />
                <h4>Character</h4>
              </a>

              <a
                href="#"
                class="inventory_btn mr-0 mr-lg-4"
                @click.prevent="
                  info = [];
                  init('guns');
                "
              >
                <img src="/images/guns-img.png" alt="" class="img-fluid" />
                <h4>Guns</h4>
              </a>
              <a
                href="#"
                class="inventory_btn"
                @click.prevent="
                  info = [];
                  init('resource');
                "
              >
                <img src="/images/tool.png" alt="" class="img-fluid" />
                <h4>Resource</h4>
              </a>
            </div>
            <div class="inventory-content inventory-page">
              <div class="unstacked_section">
                <div class="left_side scrollbar">
                  <img
                    src="/images/loader-sm.gif"
                    class="loader-con"
                    alt="loading"
                    v-if="isLoading"
                  />
                  <div class="row">
                    <div
                      class="col-lg-4 col-md-6 col-4"
                      v-for="(item, index) in info"
                      :key="index"
                    >
                      <div
                        class="inventory_img wood-card-frame"
                        v-if="schema == 'guns'"
                        :class="
                          selectedCards.indexOf(item.asset_id) != -1
                            ? 'selected-img'
                            : ''
                        "
                      >
                        <a
                          class="nftInner"
                          href="#"
                          @click.prevent="addCard(item.asset_id)"
                        >
                          <VideoBlock :link="item.template.template_id" />
                        </a>
                      </div>
                      <div
                        class="inventory_img wood-card-frame"
                        :class="
                          selectedCards.indexOf(item.asset_id) != -1
                            ? `selected-img ${schema}`
                            : schema
                        "
                        v-else
                      >
                        <a
                          class="nftInner"
                          href="#"
                          @click.prevent="addCard(item.asset_id)"
                        >
                          <VideoBlock :link="item.template.template_id" />
                        </a>
                      </div>
                    </div>
                    <div class="col-md-12 col-12" v-if="info.length == 0">
                      <h3 class="text-default">No record</h3>
                    </div>
                  </div>
                </div>
                <div class="bottom_btn text-center">
                  <a href="#" class="unstake_btn" @click.prevent="stake()">
                    <img
                      src="/images/polygon-button.png"
                      class="img-fluid"
                      alt=""
                    />
                    <h5>Stake</h5>
                  </a>
                </div>
              </div>
              <div class="stick">
                <img src="/images/stick.png" alt="" />
              </div>
              <div class="stake_section">
                <div class="left_side scrollbar">
                  <img
                    src="/images/loader-sm.gif"
                    class="loader-con"
                    alt="loading"
                    v-if="isLoading"
                  />
                  <div class="row">
                    <div
                      class="col-4 col-lg-4 col-md-6"
                      v-for="(item, index) in inventory"
                      :key="index"
                    >
                      <div
                        class="inventory_img wood-card-frame"
                        :class="
                          selectedStakeCards.indexOf(item.key) != -1
                            ? `selected-img ${schema}`
                            : schema
                        "
                      >
                        <a
                          href="#"
                          @click="addSCard(item.key, schema)"
                          class="position-relative d-block h-100 w-100"
                        >
                          <div class="locked-img" v-if="item.value.locked">
                            <i class="bi bi-lock-fill"></i>
                          </div>
                          <VideoBlock :link="item.value.templ_id" />

                          <div
                            class="progress-wrapper"
                            v-if="item.value.schema != 'resource'"
                          >
                            <div class="progress mb-1">
                              <div
                                v-if="item.value.schema == 'guns'"
                                class="progress-bar bg-warning"
                                role="progressbar"
                                :style="{
                                  width: (item.value.energy / 330) * 100 + '%',
                                }"
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              >
                                {{ item.value.energy }}
                              </div>
                              <div
                                v-if="item.value.schema == 'characters'"
                                class="progress-bar bg-success"
                                role="progressbar"
                                :style="{
                                  width: (item.value.energy / 20) * 100 + '%',
                                }"
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              >
                                {{ item.value.energy }}
                              </div>
                            </div>
                          </div>
                          <div
                            class="animation-bottom fadeIn-bottom"
                            v-if="
                              item.value.schema == 'characters' &&
                              !item.value.locked
                            "
                          >
                            <div class="buttons-wrapper">
                              <p class="text-default">
                                Level {{ item.value.level }}
                              </p>
                              <a
                                href="JavaScript:void(0)"
                                @click="openModal(item)"
                                class="position-relative btn btn-outline"
                              >
                                refill
                              </a>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bottom_btn text-center">
                  <a href="#" class="stake_btn" @click.prevent="unstake()">
                    <img
                      src="/images/polygon-button-2.png"
                      class="img-fluid"
                      alt=""
                    />
                    <h5>Unstake</h5>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RefillEnergyModal
      v-if="showModal"
      :items="selectedCard"
      v-on:w-modal-hide-click="showModal = false"
    />
  </div>
</template>

<script>
import ApiService from "../services";
import RefillEnergyModal from "../components/Modal/RefillEnergyModal.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
import VideoBlock from "../components/VideoBlock.vue";
export default {
  name: "Inventory",
  components: {
    VideoBlock,
    RefillEnergyModal,
  },
  computed: {
    ...mapGetters(["myChars", "myGuns", "inventory"]),
  },

  showModal: true,
  data() {
    return {
      info: [],
      isLoading: false,
      showModal: false,
      isImageLoaded: false,
      apiRes: null,
      selectedCard: {},
      myInventory: null,
      isSelected: false,
      schema: "characters",
      imageFailed: [],
      selectedStakeCards: [],
      selectedCards: [],
    };
  },
  created() {
    this.init(this.schema);
  },
  methods: {
    openModal(value) {
      this.showModal = true;
      this.selectedCard = value;
    },
    addCard(item) {
      let itemIndex = this.selectedCards.indexOf(item);
      if (itemIndex === -1) {
        this.selectedCards.push(item);
      } else {
        this.selectedCards.splice(itemIndex, 1);
      }
    },
    addSCard(item, schema) {
      if (schema == "characters") {
        let itemIndex = this.selectedStakeCards.indexOf(item);
        if (itemIndex === -1) {
          this.selectedStakeCards.push(item);
        } else {
          this.selectedStakeCards.splice(itemIndex, 1);
        }
      }
      console.log(this.selectedStakeCards);
    },
    async stake() {
      if (this.selectedCards.length == 0) {
        ApiService.errorMsg("Please select atleast one card to stake.");
      } else {
        const data = {
          from: localStorage.getItem("wax_user"),
          asset_ids: this.selectedCards,
          to: process.env.VUE_APP_CONTRACT,
          memo: "stake:inventory",
        };
        await ApiService.assetTransfer(
          data,
          (res) => {
            if (res.processed) {
              this.isLoading = true;
              this.removeCards();
              setTimeout(() => {
                ApiService.successMsg();
                this.loadInventory(this.schema, true);
                this.selectedCards = [];
                this.isLoading = false;
              }, 2000);
            }
          },
          (error) => {
            ApiService.errorMsg(error);
          }
        );
      }
    },
    async unstake() {
      if (this.selectedStakeCards.length == 0) {
        ApiService.errorMsg("Please select atleast one card to unstake.");
      } else {
        this.isLoading = true;
        const data = {
          contract: process.env.VUE_APP_CONTRACT,
          action: "rminv",
          data: {
            owner: localStorage.getItem("wax_user"),
            asset_ids: this.selectedStakeCards,
          },
        };
        await ApiService.transaction(
          data,
          (res) => {
            if (res.processed) {
              this.isLoading = true;
              ApiService.successMsg(
                "Transaction successfull, refresh inventory..."
              );
              setTimeout(() => {
                this.init(this.schema, true);
                this.selectedStakeCards = [];
              }, 5000);
            }
          },
          (error) => {
            ApiService.errorMsg(error);
          }
        );
      }
    },
    isLocked(d) {
      return ApiService.isExpired(d);
    },
    removeCards() {
      this.info = this.info.filter(
        (i) => !this.selectedCards.includes(i.asset_id)
      );
    },
    loadInventory(schema) {
      // if (this.inventory.length>0 && !refresh) {
      //   console.log(this.inventory);
      //   this.myInventory = this.inventory.filter(
      //     (i) => i.value.schema == schema
      //   );
      //   this.$store.commit("addInventory", this.myInventory);
      // } else {
      if (this.inventory.length > 0) this.$store.commit("addInventory", []);
      this.isLoading = true;
      ApiService.getInventory((res) => {
        this.myInventory = res.filter((i) => i.value.schema == schema);
        this.myInventory.map(async (item, i) => {
          this.myInventory[i].value.locked = ApiService.isExpired(
            item.value.lock_end
          );
        });
        this.$store.commit("addInventory", this.myInventory);
        this.isLoading = false;
      });
      // }
      this.selectedCards = [];
      this.selectedStakeCards = [];
      this.schema = schema;
    },
    init(schema, refresh = false) {
      // if (schema == "guns" && this.myGuns && !refresh) {
      //   this.info = this.myGuns;
      // } else if (schema == "characters" && this.myChars && !refresh) {
      //   this.info = this.myChars;
      // } else {
      this.isLoading = true;
      ApiService.callApi(
        `&collection_name=${process.env.VUE_APP_COLLECTION}&schema_name=${schema}`,
        (response) => {
          let res = response["data"];
          if (res["success"]) {
            this.apiRes = res["data"];
            this.info = this.apiRes;
            if (schema == "guns") {
              this.$store.commit("addGuns", this.info);
            } else {
              this.$store.commit("addChars", this.info);
            }
          } else {
            this.info = [];
          }
          this.isLoading = false;
        }
      );
      // }
      this.loadInventory(schema, refresh);
    },
  },
};
</script>
<style scoped>
.top_btns {
  z-index: 1;
}
.wood-card-frame {
  padding: 13px 11px;
}
.page_bg {
  background-size: 100% 100%;
}
.dyn-img {
  width: 120px;
}
.main_inventory {
  height: 500px;
  width: 100%;
}
.img_main {
  background: url("/images/inventory-layer.png") no-repeat center center;
  background-size: 100% 100%;
  height: 100%;
  width: 90%;
  margin: 0 auto;
}
.inventory-content {
  display: flex;
  padding: 5px 20px 0 14px;
  height: 100%;
}
.hide-button {
  display: none;
  cursor: alias;
}
.animation-bottom {
  transform: translate(-50%, -50%) !important;
}
.locked-img {
  color: #fff;
  font-size: 25px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.unstacked_section {
  width: 100%;
  position: relative;
  top: 22px;
  left: 10px;
}
.stick {
  height: 100%;
  position: relative;
  top: 6px;
  width: inherit;
}
.stick img {
  height: 100%;
}

.left_side .col-4 {
  padding-right: 0px;
}

.stake_section {
  width: 100%;
  position: relative;
  top: 24px;
  right: 8px;
  z-index: 1;
}
.stake_section .img-frame::after {
  content: "";
  background: rgba(0, 0, 0, 0.1);
  display: block;
  width: 77%;
  height: 82%;
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 23px;
}

.progress-wrapper {
  width: 70%;
  position: absolute;
  bottom: 10px;
  margin: auto;
  left: 16px;
}
.resource {
  width: 150px !important;
}
.progress-wrapper .progress {
  height: 0.8rem !important;
}

.buttons-wrapper {
  width: 70px;
  margin: auto;
}
.btn-outline {
  /* border: 1px solid green; */
  color: #fff;
  padding: 0px 14px;
  background: green;
  font-size: 11px;
  width: 100%;
}
.btn:hover {
  color: #fff !important;
}
@media (max-width: 768px) {
  .stick {
    display: none;
  }
  .inventory-content {
    display: inline-block;
  }
  /* .img_main{
    height: 225vh;
  } */
  .main_inventory {
    height: 100%;
  }
  .unstacked_section {
    left: 0px;
  }
  .stake_section {
    right: 0px;
  }
  .progress-wrapper {
    bottom: 30px;
    left: 18px;
    width: 70%;
  }
}
</style>